import axios from 'axios'
import fileSaver from 'file-saver'

export default{
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getResources ({commit, state, rootState}) {
      return axios.get(`/api/company/${rootState.userCurrentCompany.companyId}/resources`).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getResourcesByFolderId ({commit, state, rootState}, args) {
      console.log('args: ' + JSON.stringify(args, null, 2))

      var apiPath = ''
      if (args.folderType.toLowerCase() === 'property' && args.propertyId === null) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/resources/properties`
      } else if (args.folderType.toLowerCase() === 'property' && args.propertyId !== null) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/resources/folders/${args.folderId}`
      } else {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/resources/folder/${args.folderId}`
      }

      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async getFolderForEdit ({rootState}, args) {
      var apiPath = ''
      if (args.propertyId === null) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/resources/folder/${args.folderId}/edit`
      } else {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/properties/${args.propertyId}/resources/folders/${args.folderId}/edit`
      }
      return axios.get(apiPath).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    async saveFolder ({rootState}, args) {
      console.log('Saving folder: ' + JSON.stringify(args.folder, null, 2))
      var apiPath = ''
      if (args.folder.propertyId === null || args.folder.propertyId === undefined) {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/resources/folder/save`
      } else {
        apiPath = `/api/company/${rootState.userCurrentCompany.companyId}/properties/${args.folder.propertyId}/resources/folder/save`
      }
      return axios.post(apiPath, args.folder).then((result) => {
        console.log(result.data)
        return result.data
      })
        .catch((e) => console.log(`Error: the server responded with '${e}: ${e}'`))
    },
    uploadDocument ({rootState}, args) {
      console.log('Upload clicked. for event: ' + args.name)
      console.log('stringify ', JSON.stringify(args, null, 2))
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)

      var apiPath = ''
      if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/resources/folders/${args.folderId}/documents/${encodeURIComponent(args.fileName)}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/resources/folders/${args.folderId}/documents/${encodeURIComponent(args.fileName)}`
      }
      return axios.post(apiPath, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          params: {name: args.name, note: args.note}
        })
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    async downloadDocument ({commit, state, rootState, dispatch}, args) {
      console.log('Download clicked for document:', args.documentId)
      var apiPath = ''
      if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/documents/${args.documentId}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/documents/${args.documentId}`
      }
      return axios.get(apiPath,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    uploadImage ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for image: ' + args.name)
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)

      var apiPath = ''
      if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/resources/folders/${args.folderId}/images/${encodeURIComponent(args.fileName)}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/resources/folders/${args.folderId}/images/${encodeURIComponent(args.fileName)}`
      }
      return axios.post(apiPath, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          params: {name: args.name, note: args.note}
        })
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    async downloadImage ({commit, state, rootState, dispatch}, args) {
      console.log('Download clicked for image:', args.imageId)
      var apiPath = ''
      if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/images/${args.imageId}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/images/${args.imageId}`
      }
      return axios.get(apiPath,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    uploadVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Upload clicked. for video: ' + args.name)
      const file = args.file
      let formData = new FormData()
      formData.append('file', file)

      var apiPath = ''
      if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/resources/folders/${args.folderId}/videos/${encodeURIComponent(args.fileName)}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/resources/folders/${args.folderId}/videos/${encodeURIComponent(args.fileName)}`
      }
      return axios.post(apiPath, formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          params: {name: args.name, note: args.note}
        })
        .then((result) => {
          return result
        }).catch(error => {
          console.log(error)
        })
    },
    async downloadVideo ({commit, state, rootState, dispatch}, args) {
      console.log('Download clicked for video:', args.videoId)
      var apiPath = ''
      if (args.propertyId === null) {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/videos/${args.videoId}`
      } else {
        apiPath = `${process.env.DOCS_API_URL}api/company/${rootState.userCurrentCompany.companyId}/property/${args.propertyId}/videos/${args.videoId}`
      }
      return axios.get(apiPath,
        {
          responseType: 'blob',
          headers: {'accept': 'application/octet-stream'}
        }).then(response => {
        console.log(response)
        fileSaver.saveAs(response.data, args.fileName)
      }).catch(error => {
        console.log(error)
      })
    },
    async getAcceptedFileTypes ({commit, state, rootState, dispatch}, args) {
      console.log('getting accepted document types')
      // types: 1 = document, 2 = image, 3 = video
      const types = [
        // Documents
        {type: 1, ext: 'pdf', class: 'fas fa-file-pdf', color: 'rgb(244, 15, 2)'},
        {type: 1, ext: 'xlsx', class: 'fas fa-file-excel', color: 'green'},
        {type: 1, ext: 'xls', class: 'fas fa-file-excel', color: 'green'},
        {type: 1, ext: 'csv', class: 'fas fa-file-excel', color: 'green'},
        {type: 1, ext: 'ppt', class: 'fas fa-file-powerpoint', color: 'rgb(204, 85, 0)'},
        {type: 1, ext: 'pptx', class: 'fas fa-file-powerpoint', color: 'rgb(204, 85, 0)'},
        {type: 1, ext: 'docx', class: 'fas fa-file-word', color: 'rgb(64, 114, 196)'},
        {type: 1, ext: 'doc', class: 'fas fa-file-word', color: 'rgb(64, 114, 196)'},
        {type: 1, ext: 'txt', class: 'fas fa-file', color: 'rgb(92, 92, 92)'},
        // Images
        {type: 2, ext: 'jpg', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'jpeg', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'gif', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'png', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'heic', class: 'fas fa-image', color: 'blue'},
        {type: 2, ext: 'heif', class: 'fas fa-image', color: 'blue'},
        // Videos
        {type: 3, ext: 'mov', class: 'fas fa-video', color: 'orange'},
        {type: 3, ext: 'mp4', class: 'fas fa-video', color: 'orange'},
        {type: 3, ext: 'webm', class: 'fas fa-video', color: 'orange'}
      ]

      return new Promise(resolve => {
        resolve(types)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/eventresources.js